module.exports = __webpack_public_path__ + "outlook-calendar.png";